import { Link } from "react-router-dom";
import { LogoLockup } from "./Logo";
import { VINEOPS_URL, CONTACT, scrollToSection } from "../constants/site";

const goTo = (id) => {
  if (document.getElementById(id)) {
    scrollToSection(id);
  } else {
    window.location.href = `/#${id}`;
  }
};

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#12271B] text-[#F9F6F0]">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <LogoLockup light size="footer" />
          <p className="mt-8 text-sm leading-relaxed text-[#F9F6F0]/55 max-w-[40ch]">
            Premium vineyard management for the winegrowing estates of Napa and Sonoma. Quality farming, deep experience, and complete visibility into your vineyard data.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#B89B67] font-semibold mb-6">Site</p>
          <ul className="space-y-3 text-sm text-[#F9F6F0]/70">
            {[["Philosophy", "philosophy"], ["Services", "services"], ["Regions", "regions"], ["VineOps", "vineops"], ["FAQ", "faq"], ["Contact", "contact"]].map(([label, id]) => (
              <li key={id}>
                <button data-testid={`footer-link-${id}`} onClick={() => goTo(id)} className="hover:text-[#B89B67] transition-colors duration-300">
                  {label}
                </button>
              </li>
            ))}
            <li>
              <Link data-testid="footer-link-about" to="/about" className="hover:text-[#B89B67] transition-colors duration-300">
                About Us
              </Link>
            </li>
            <li>
              <Link data-testid="footer-link-safety" to="/safety" className="hover:text-[#B89B67] transition-colors duration-300">
                Safety &amp; Training
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#B89B67] font-semibold mb-6">Reach Us</p>
          <ul className="space-y-3 text-sm text-[#F9F6F0]/70">
            <li>
              <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="hover:text-[#B89B67] transition-colors duration-300">{CONTACT.email}</a>
            </li>
            <li className="pt-4">
              <a data-testid="footer-client-login" href={VINEOPS_URL} target="_blank" rel="noopener noreferrer" className="text-[#B89B67] hover:text-[#F9F6F0] transition-colors duration-300 tracking-[0.14em] uppercase text-xs font-semibold">
                VineOps Client Login
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="hairline-t-dark mt-20 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <p className="text-xs text-[#F9F6F0]/40">© {new Date().getFullYear()} Vinedresser Vineyard Management, Inc. All rights reserved.</p>
        <p className="text-xs text-[#F9F6F0]/40">Napa Valley · Sonoma County · California</p>
      </div>
    </div>
  </footer>
);
